import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-version-update-notification',
  template: `
    <div 
      class="version-notification" 
      [@slideIn]="isVisible ? 'in' : 'out'"
      *ngIf="isVisible"
    >
      <div class="notification-content">
        <div class="icon">
          <i class="fa-solid fa-download"></i>
        </div>
        <div class="message">
          <h4 translate>components.versionUpdate.title</h4>
          <p translate>components.versionUpdate.message</p>
        </div>
        <div class="actions">
          <button 
            class="btn-update" 
            (click)="onUpdate()"
            translate
          >
            components.versionUpdate.update
          </button>
          <button 
            class="btn-dismiss" 
            (click)="onDismiss()"
            translate
          >
            components.versionUpdate.later
          </button>
        </div>
        <button class="btn-close" (click)="onDismiss()">
          <i class="fa-solid fa-times"></i>
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./version-update-notification.component.scss'],
  animations: [
    trigger('slideIn', [
      state('in', style({ transform: 'translateY(0)', opacity: 1 })),
      state('out', style({ transform: 'translateY(-100%)', opacity: 0 })),
      transition('out => in', animate('300ms ease-in')),
      transition('in => out', animate('300ms ease-out'))
    ])
  ]
})
export class VersionUpdateNotificationComponent implements OnInit {
  @Input() isVisible: boolean = false;
  @Input() newVersion: string = '';
  @Input() currentVersion: string = '';
  
  @Output() update = new EventEmitter<void>();
  @Output() dismiss = new EventEmitter<void>();

  ngOnInit(): void {
    // Auto-hide after 15 seconds if user doesn't interact
    if (this.isVisible) {
      setTimeout(() => {
        if (this.isVisible) {
          this.onDismiss();
        }
      }, 15000);
    }
  }

  onUpdate(): void {
    this.update.emit();
  }

  onDismiss(): void {
    this.isVisible = false;
    this.dismiss.emit();
  }
}
